import React, {useState, useEffect} from 'react';
import api from '../services/api';
import '../styles/CustomerPage.css';

export default function CustomerModal({customer, onClose, onSave}) {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        comment: '',
        contactPerson: ''
    });

    useEffect(() => {
        if (customer) {
            setFormData(customer);
        }
    }, [customer]);

    const handleSubmit = () => {
        const request = customer
            ? api.patch(`/company/${customer.id}`, formData)
            : api.post('/Company', formData);

        request
            .then(() => onSave())
            .catch(() => alert('Fehler beim Speichern.'));
    };

    return (
        <div className="modal-backdrop">
            <div className="modal">
                <h3>{customer ? 'Kunde bearbeiten' : 'Neuer Kunde'}</h3>
                <input placeholder="Name" value={formData.name}
                       onChange={e => setFormData({...formData, name: e.target.value})}/>
                <input placeholder="Adresse" value={formData.address}
                       onChange={e => setFormData({...formData, address: e.target.value})}/>
                <input placeholder="Kommentar" value={formData.comment}
                       onChange={e => setFormData({...formData, comment: e.target.value})}/>
                <input placeholder="Ansprechpartner" value={formData.contactPerson}
                       onChange={e => setFormData({...formData, contactPerson: e.target.value})}/>

                <div className="modal-actions">
                    <button className="button-normal" onClick={handleSubmit}>Speichern</button>
                    <button className="button-danger" onClick={onClose}>Abbrechen</button>
                </div>
            </div>
        </div>
    );
}
